// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Uvnav","title":"Footer_title__gRqZa","text":"Footer_text__sevHI"};